"use client"

import React, { useEffect } from 'react'
import MenuTitle from "@/app/components/menuTitle";
import Video from "./video";
import { useTitleStore } from '@/stores';

const Page: React.FC = () => {

  const {setSelectedTitle} = useTitleStore();

  useEffect(() => {
    setSelectedTitle('UTM > 화상감시시스템');
  },[])

  return (
    <div>
      <MenuTitle/>
      <Video/>
    </div>
  );
};
  
  export default Page;